import { NavLink } from "react-router"

export function mapReachMenuLinkProps({
  href,
  ...rest
}: {
  href: string
  [key: string]: unknown
}) {
  if (href.startsWith(window.origin)) href = href.replace(window.origin, "")
  const isChurchCenterHref = href.startsWith("/")
  const key = href
  if (isChurchCenterHref)
    return {
      as: NavLink,
      key,
      to: href,
      ...rest,
    }
  else
    return {
      as: "a",
      key,
      href,
      target: "_blank",
      rel: "noopener noreferrer",
      ...rest,
    }
}
